export default {

  /**
   * Application Name
   *
   * This value is the name of your application.This value is used when the
   * framework needs to place the application 's name in a notification or
   * any other location as required by the application or its packages.
   */

  APP_NAME: 'RBS Report',

  /**
   * Application Debug Mode
   *
   * This value is your application's development mode.
   * This value determines in which mode your app will receive.
   * You can change this.
   */

  APP_DEBUG: process.env.NODE_ENV === 'development',

  /**
   * Application Environment
   *
   * This value determines the "environment" your application is currently
   * running in .This may determine how you prefer to configure various
   * services the application utilizes.
   */

  NODE_ENV: process.env.NODE_ENV,

  /**
   * Application Public URL
   *
   * This option controls the default website address for your app.
   * You can change these defaults as needed,
   * but it is an important option for the application.
   */

  PUBLIC_URL: process.env.PUBLIC_URL,

  /**
   * Encryption Key
   *
   * This key is used by the Illuminate encrypter service and should be set
   * to a random, 12 character string, otherwise these encrypted strings
   * will not be safe. Please do this before deploying an application!
   *
   */

  APP_KEY: 'PNRM80F840H',

  /**
   * WebSocket URL for AI
   *
   * This value is the WebSocket server URL for real-time communication.
   * You can change this value based on your environment.
   */

  WEBSOCKET_URL: process.env.REACT_APP_WEBSOCKET_URL || 'wss://ai.rbs.report/ws',

  /**
   * API URL for AI
   *
   * This value is the API server URL for HTTP requests.
   * You can change this value based on your environment.
   */

  API_URL: process.env.REACT_APP_API_URL || 'https://ai.rbs.report',
};
